<template>
    <div class="artwork-file-box box">
        <h3 class="box-title">
            Episode Artwork
        </h3>

        <p class="box-description">
            JPG or PNG, square image between 1,400 and 3,000 pixels.
        </p>

        <div class="artwork-select">
            <artwork-file-option
                class="default"
                :is-selected="artwork === null"
                label="Default"
                :file="defaultArtwork"
                @select="() => changeArtwork(null)"
            />

            <artwork-file-option-custom
                :is-selected="artwork !== null"
                label="Custom artwork"
                :file="artwork"
                @select="file => changeArtwork(file)"
            />
        </div>

        <form-error
            v-if="!! error"
            :error="error"
        />
    </div>
</template>
<script>
import ArtworkFileOption from './ArtworkFileOption';
import ArtworkFileOptionCustom from './ArtworkFileOptionCustom';
import FormError from '@/components/Form/FormError';
import episodeModal from '@/utils/episodeModal';

export default {
    components: {
        ArtworkFileOption,
        ArtworkFileOptionCustom,
        FormError,
    },

    props: {
        defaultArtwork: {
            default: null,
            type: [String, File],
        },
    },

    computed: {
        /**
         * Gets the artwork.
         *
         * @returns {string|File|null} Artwork.
         */
        artwork() {
            return episodeModal.getArtworkFile();
        },

        /**
         * Gets the error for artwork field.
         *
         * @returns {string|null} Error message..
         */
        error() {
            return episodeModal.getError('artwork');
        },
    },

    methods: {
        /**
         * Handles change of artwork.
         *
         * @param  {File|null} file File instance.
         */
        changeArtwork(file = null) {
            episodeModal.clearError('artwork');
            episodeModal.setArtworkFile(file);
        },
    },
};
</script>
